import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO2 = {
  title: "Identify the impacted services \nand proactive notifications",
  subtitle: "Network operations demo",
  text: '<span style="font-weight:bold">Customer delight</span> — enabling timely and\neffective resolution to maximize the customer\nexperience.',
  label: { iconPath: "start.png", text: "Notification module" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_210"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_208"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_demo_screens_base.png",
  rightSideVideo: "ILO/ILO2/INF_CMT_827.23_Network Demo_Part 6_R1.mp4",
  pageNumber: "ILO_209",
};

export default DATA_NO_DEMO_ILO2;
